import React, { useState } from 'react';
import api from '../services/api';
import './SharkManagement.css';
import './Button.css';

function AddFish() {
    const [sharkId, setSharkId] = useState('');
    const [round, setRound] = useState(1);
    const [weightLbs, setWeightLbs] = useState('');
    const [weightOz, setWeightOz] = useState(0);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage('');
        try {
            await api.post('/sharks/', {
                shark_id: sharkId.trim().toUpperCase(),
                weight_lbs: parseInt(weightLbs, 10),
                weight_oz: parseInt(weightOz, 10) || 0,
                round: parseInt(round, 10),
            });
            setMessage(`Shark ${sharkId.trim().toUpperCase()} added to Round ${round}.`);
            setMessageType('success');
            setSharkId('');
            setWeightLbs('');
            setWeightOz(0);
        } catch (error) {
            const detail = error.response?.data?.detail || 'Failed to add shark.';
            setMessage(detail);
            setMessageType('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="shark-mgmt-container">
            <h2>Add Shark</h2>
            <form className="shark-mgmt-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="shark-id">Shark ID</label>
                    <input
                        id="shark-id"
                        type="text"
                        value={sharkId}
                        onChange={(e) => setSharkId(e.target.value)}
                        placeholder="e.g. F001"
                        required
                        autoFocus
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="round">Round</label>
                    <select
                        id="round"
                        value={round}
                        onChange={(e) => setRound(Number(e.target.value))}
                    >
                        <option value={1}>Round 1</option>
                        <option value={2}>Round 2</option>
                        <option value={3}>Round 3</option>
                    </select>
                </div>
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="weight-lbs">Weight (lbs)</label>
                        <input
                            id="weight-lbs"
                            type="number"
                            min="0"
                            value={weightLbs}
                            onChange={(e) => setWeightLbs(e.target.value)}
                            placeholder="0"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="weight-oz">Weight (oz)</label>
                        <input
                            id="weight-oz"
                            type="number"
                            min="0"
                            max="15"
                            value={weightOz}
                            onChange={(e) => setWeightOz(e.target.value)}
                            placeholder="0"
                        />
                    </div>
                </div>
                <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Adding...' : 'Add Shark'}
                </button>
            </form>
            {message && <p className={`message ${messageType}`}>{message}</p>}
        </div>
    );
}

export default AddFish;
